import { IJudgmentKind } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentKind';
import { IKnmJudgmentKindSelectOption } from '../interfaces/IKnmJudgmentKindSelectOption';

export const createJudgmentKindSelectOption = (erknmJudgmentKind: IJudgmentKind): IKnmJudgmentKindSelectOption => ({
  ...erknmJudgmentKind,
  label: erknmJudgmentKind.name,
  value: erknmJudgmentKind.id,
});
